import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

export interface GlobalOkDialogState {
  show: boolean,
  resolve: ((value: void | PromiseLike<void>) => void)|null,
  content: React.ReactNode | null,
  hideOkButton: boolean,
  top: string|null,
  inform: string,
  warning: string,
  error: string,
  type:'info'|'error'|'warning',
};

export interface GlobalOkDialogData {
  resolve: ((value: void | PromiseLike<void>) => void)|null,
  content: React.ReactNode | null,
  hideOkButton?: boolean,
  top?: string|null,
  inform?: string,
  warning?: string,
  error?: string,
  type:'info'|'error'|'warning',

};

const initialState:GlobalOkDialogState = {
  show: false,
  resolve: null,
  content: null,
  hideOkButton: false,
  top: null,
  inform:'',
  warning:'',
  error:'',
  type:'info',

};

/**
 * Slice for controlling Global Ok Dialog
 */
const globalOkDialogSlice = createSlice({
  name: 'globalOkDialog',
  initialState,
  reducers: {
    showGlobalOkDialog: (state, action: PayloadAction<GlobalOkDialogData>) => {
      state.show = true;
      state.resolve = action.payload.resolve;
      state.content = action.payload.content;
      state.hideOkButton = action.payload.hideOkButton ?? false;
      state.top = action.payload.top ?? null;

      state.type = action.payload.type ?? 'info';

      state.inform = action.payload.type === 'info' ? '' : 'none';
      state.warning = action.payload.type === 'warning'? '' : 'none';
      state.error = action.payload.type === 'error'? '' : 'none';

    },
    hideGlobalOkDialog: (state) => {
      state.show = false;
      state.resolve = null;
      state.content = null;
      state.hideOkButton = false;
      state.top = null;
      state.type =  'info';
      
    },
  }
});

export default globalOkDialogSlice.reducer;

export const { showGlobalOkDialog, hideGlobalOkDialog } = globalOkDialogSlice.actions;
